import types from '@/types';

const createPersonModule = (personService) => ({
  namespaced: true,
  state: {
    person: {},
    persons: [],
    totalPersons: 0,
  },

  mutations: {
    [types.SET_PERSONS](state, persons = []) {
      state.persons = persons;
    },
    [types.SET_PERSON](state, person) {
      state.person = person;
    },
    SET_TOTAL_PERSONS(state, totalPersons) {
      state.totalPersons = totalPersons;
    },
  },

  actions: {
    // eslint-disable-next-line no-unused-vars
    [types.SEARCH_BY_IMAGE]({ commit }, data) {
      return personService.searchByImage(data);
    },
    [types.GET_PERSON]({ commit }, personId) {
      return personService.get(personId)
        .then((response) => {
          commit(types.SET_PERSON, response.data);
        });
    },
  },
});

export default createPersonModule;



// WEBPACK FOOTER //
// ./src/store/modules/person.js